/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
 */

/**
 * Properties mapper for the GraphicGapMatchInteraction and its choices
 */

/**
 * Export the mapper
 */
export default {
    /**
     * Map the received choice properties
     * @param {Object} choiceProperties - received properties
     * @returns {Object} mapped properties
     */
    mapChoiceProperties(choiceProperties = {}) {
        //the component expect the choice identifier under the `key` property
        if (choiceProperties.identifier) {
            choiceProperties.key = choiceProperties.identifier;
            delete choiceProperties.identifier;
        }

        return choiceProperties;
    },

    /**
     * Map itemData properties to interaction props
     * @param {Object} properties
     * @param {object} element
     * @param {string} element.gapImgs
     * @returns {Object} mapped properties
     */
    mapProperties(properties, { gapImgs } = {}) {
        //for clarity, move the image object under a more expressive property name
        if (properties.object) {
            properties.imgObject = properties.object;
            delete properties.object;
        }
        //for clarity, rename collection of associable hotspots
        if (properties.choices) {
            properties.gaps = properties.choices;
            delete properties.choices;
        }
        //parse gapImgs, the collection of images; and for clarity, rename
        if (typeof gapImgs === 'object') {
            const gapImgSets = [].concat(gapImgs);
            properties.choices = gapImgSets.map(gapImgSet => {
                const gapImgSetProperties = Object.values(gapImgSet).map(gapImg => {
                    //flatten 'gapImg.attributes' and 'gapImg.object.attributes'; rename 'identifier' to 'key'
                    let gapImgProperties = Object.assign({}, gapImg.attributes);
                    if (gapImgProperties.identifier) {
                        gapImgProperties.key = gapImgProperties.identifier;
                        delete gapImgProperties.identifier;
                    }
                    if (gapImg.object) {
                        gapImgProperties = Object.assign(gapImgProperties, gapImg.object.attributes);
                    }
                    return gapImgProperties;
                });
                return gapImgSetProperties;
            });
            // flatten choices array if there was only 1 choice set
            if (gapImgSets.length === 1) {
                properties.choices = properties.choices[0];
            }
        }

        return properties;
    }
};
